module.exports = __webpack_public_path__ + "static/img/order-coupon-bottom.d2c082a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/order-coupon-bottom.png
// module id = 338
// module chunks = 7